import { formatDate } from "_helper/utils";
import { FORM_ERROR_MESSAGES } from "Constant";
import { TableColumn } from "react-data-table-component";
import { UseFormReturn } from "react-hook-form";
import { Badge } from "reactstrap";

export const REPORT_TYPE = [
  {
    text: "Tổng hợp số liệu báo cáo về xử phạt vi phạm hành chính",
    value: "1",
  },
  {
    text: "TỔNG HỢP SỐ LIỆU BÁO CÁO VỀ ÁP DỤNG CÁC BIỆN PHÁP XỬ LÝ HÀNH CHÍNH",
    value: "2",
  },
];

export enum TRANG_THAI {
  DA_TAO = 0,
  DA_CAP_NHAT = 1,
  DA_HOAN_THANH = 2,
}

const TRANG_THAI_VALUES = {
  0: "Đã tạo",
  1: "Đã cập nhật",
  2: "Đã hoàn thành",
};

export const useListTableColumns = () => {
  const tableColumns: TableColumn<any>[] = [
    {
      name: "Tên báo cáo",
      selector: (row) => row.tenBaoCao,
    },
    {
      name: "Loại báo cáo",
      selector: (row) => row.tenMauBaoCao,
    },
    {
      name: "Mẫu",
      selector: (row) => row.mauSoBaoCao,
    },
    {
      name: "Từ ngày",
      selector: ({ fromDate }) => formatDate(fromDate),
    },
    {
      name: "Đến ngày",
      selector: ({ toDate }) => formatDate(toDate),
    },
    {
      name: "Trạng thái",
      selector: ({ status }) => (
        <Badge color={status === TRANG_THAI.DA_TAO ? "danger" : "success"}>
          {TRANG_THAI_VALUES[status]}
        </Badge>
      ),
    },
  ];
  return { tableColumns };
};

export const useFormFields = (useFormReturn?: UseFormReturn) => {
  return [
    {
      name: "tenBaoCao",
      label: "Tên báo cáo",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "loaiBaoCao",
      label: "Loại báo cáo",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "mau",
      label: "Mẫu",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "tuNgay",
      label: "Từ ngày",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "denNgay",
      label: "Đến ngày",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "trangThai",
      label: "Trạng thái",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
  ].flat() as any;
};

export const title = "Danh Sách Báo Cáo";
export const parent = "Báo Cáo";
